module.exports = __webpack_public_path__ + "static/media/bcaa.64032273.png";